(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SpeechRecognitionMock", [], factory);
	else if(typeof exports === 'object')
		exports["SpeechRecognitionMock"] = factory();
	else
		root["SpeechRecognitionMock"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition